import { EnumPartitionID, EnumProductType } from '../defines/enums'

/**
 * 是否是抖音商品
 * @param {number} partitionID partition_id
 * @returns boolean
 */
export const isDYPart = partitionID => partitionID - 0 === EnumPartitionID.DY
/**
 * 套餐支持的xenv列表
 */
export const SupportXenvLists = [
  'wxmp',
  'alimp',
  'yxwxmp',
  'qjwxmp',
  'dymp',
  'sfcwxmp',
  'sfcalimp',
  'esapp',
  'passenger',
  'h5',
  'hyalimp',
  'hywxmp',
  'cralimp',
  'hwfastapp',
  'hypassenger',
]
/**
 * 购买历史页面tab
 */
export const PURCHASE_HISTORY_TABS = {
  effecting: {
    key: 'effecting',
    i18nKey: 'personal.active',
    params: {
      status: 1,
    },
    desc: '生效中',
    page: 1,
    data: [],
    omegaAttr_sw: {
      state_type: 1,
    },
    omegaAttr_ck: {
      ck_type: 1,
    },
  },
  'purchase-history': {
    key: 'purchase-history',
    i18nKey: 'personal.allPurchase',
    desc: '全部',
    page: 1,
    params: {},
    data: [],
    omegaAttr_sw: {
      state_type: 2,
    },
    omegaAttr_ck: {
      ck_type: 2,
    },
    needPreload: true, // 需要提前加载下一页标志位， 每次请求4个size, 占不满一页
  },
  processing: {
    key: 'processing',
    i18nKey: 'personal.processing',
    params: {
      status: 3,
      // pay_status: [
      //   EnumOrderDetailPayStatus.Refunding,
      //   EnumOrderDetailPayStatus.PayWaitPay,
      // ].join(','),
    },
    desc: '处理中',
    page: 1,
    data: [],
    omegaAttr_sw: {
      state_type: 3,
    },
    omegaAttr_ck: {
      ck_type: 3,
    },
    needPreload: true,
  },
}

/**
 * 以partition_id维护拆分配置项
 */
export const PROD_CONFIG = {
  [EnumPartitionID.DY]: {
    purchaseHistoryListTabs: [
      // 订单列表页面tab
      PURCHASE_HISTORY_TABS['purchase-history'],
      PURCHASE_HISTORY_TABS.processing,
    ],
    component: {
      // tab对应的组件
      'purchase-history': 'good-card-dy',
      processing: 'good-card-dy',
    },
    purchaseHistoryListPhoneFlag: true, // 列表页面展示使用手机号
    goodsUsageFlag: true, // 展示商品使用说明
    purchaseHistoryTabStyle: {
      // 订单列表页面tab样式
      color: '#000000',
      'font-weight': 'normal',
    },
  },
  default: {
    purchaseHistoryListTabs: [
      PURCHASE_HISTORY_TABS.effecting,
      PURCHASE_HISTORY_TABS['purchase-history'],
    ],
    component: {
      effecting: 'order-effecting-card',
      'purchase-history': 'good-card',
    },
    purchaseHistoryTabStyle: {},
  },
}
/**
 * 以xenv维度的产品配置
 */
// export const PROD_BY_XENV_CONFIG = {
//   dymp: {
//     hideTelephone: true,
//     telephone: '01021322887',
//     hideOrderDetailContinuePay: true,
//     hideOrderDetailContinuePayTip: '暂不支持继续支付，请重新下单',
//     resultDescTips: '如有问题可前往"首页-咨询"中联系在线客服',
//   },
//   hywxmp: {
//     hideTelephone: false,
//     otherDetailPageJumpAppHome: true, // 详情页 / 下游有第三方页面时跳转主小程序
//     goodsClickJumpActivityId: 'freight_quartz_jump', // 中间页activity_id
//     telephone: '400-000-0999', // 客服电话
//     hideOrderDetailContinuePay: false,
//   },
//   hyalimp: {
//     hideTelephone: false,
//     otherDetailPageJumpAppHome: true,
//     goodsClickJumpToast: '请去滴滴出行app购买', // 跳转第三方页面时弹toast
//     telephone: '400-000-0999',
//     hideOrderDetailContinuePay: false,
//   },
//   cralimp: {
//     hideTelephone: false,
//     otherDetailPageJumpAppHome: true,
//     goodsClickJumpToast: '请去滴滴出行app购买',
//     telephone: '400-000-0999',
//     hideOrderDetailContinuePay: false,
//     otherProductTypeGoDaChe: '请到滴滴出行app使用',
//     bindProductType: EnumProductType.CarRental,
//   },
//   sfcwxmp: {
//     hideTelephone: false,
//     otherDetailPageJumpAppHome: true, // 详情页 / 下游有第三方页面时跳转主小程序
//     goodsClickJumpToast: '请去滴滴出行app购买',
//     telephone: '400-000-0999', // 客服电话
//     hideOrderDetailContinuePay: false,
//     hideShowMoreGoods: true, // 隐藏查看更多套餐
//   },
//   sfcalimp: {
//     hideTelephone: false,
//     otherDetailPageJumpAppHome: true, // 详情页 / 下游有第三方页面时跳转主小程序
//     goodsClickJumpToast: '请去滴滴出行app购买',
//     telephone: '400-000-0999', // 客服电话
//     hideOrderDetailContinuePay: false,
//     hideShowMoreGoods: true, // 隐藏查看更多套餐
//   },
//   default: {
//     hideTelephone: false,
//     telephone: '400-000-0999',
//     hideOrderDetailContinuePay: false,
//   },
// }

/**
 * 以产品类型维护的配置
 */
// export const PROD_BY_PRODUCT_TYPE = {
//   [EnumProductType.CarRental]: {
//     productType: EnumProductType.CarRental,
//     orderDetailDescI18nKey: 'orderDetail.rentCouponAvailable',
//     toRideFromService: {
//       // 打车文案和链接使用服务端下发
//       orderDetailBtnText: true, // 订单详情页按钮文案
//       orderDetailBtnLink: true, // 订单详情页按钮跳转链接
//       historyBtnText: true, // 付款结果页按钮文案
//       historyBtnLink: true, // 付款结果页按钮链接
//     },
//   },
//   [EnumProductType.WashingCard]: {
//     productType: EnumProductType.WashingCard,
//     toRideFromService: {
//       orderDetailBtnText: true,
//       orderDetailBtnLink: true,
//       historyBtnText: true,
//       historyBtnLink: true,
//     },
//   },
// }

export const STYLE_BY_PRODUCT_TYPE = {
  [EnumProductType.Default]: {
    coupon_style: {
      background_image:
        'https://ut-static.udache.com/webx/fe-agility-wyc/XOydEVFqxNjReJkymTptW.png',
      amount_color: '#000000',
      unit_color: '#FF6835',
      cap_color: 'rgba(79,39,25,0.80)',
    },
    order_detail: {
      header_bg:
        'https://dpubstatic.udache.com/static/dpubimg/ceab0e08-c898-4fd4-9204-947cade82ed2.png',
      btn_background:
        'linear-gradient(-45deg, #FF2726 0%, #FF5B43 61%, #F3520F 100%), linear-gradient(180deg, #FFE8C6, #FFDEC5)',
      btn_box_shadow:
        '0 18rpx 24rpx -8rpx rgba(255, 60, 0, .28), inset 0 -1rpx 6rpx 0 #E24444',
    },
  },
  [EnumProductType.Luxed]: {
    coupon_style: {
      background_image:
        'https://ut-static.udache.com/webx/fe-agility-wyc/_jYBb8q-XU92GCYWeUd_T.png',
      amount_color: '#000000',
      unit_color: '#9E4D1F',
      cap_color: 'rgba(103,62,31,0.56)',
    },
    order_detail: {
      header_bg:
        'https://ut-static.udache.com/webx/fe-agility-wyc/wfoTX9QqySDy-dCe7U4t6.png',
      btn_background:
        'linear-gradient(259deg, #143B5C 3%, #2E76A8 100%), linear-gradient(180deg, #FFE8C6, #FFDEC5)',
      btn_box_shadow:
        '0 18rpx 24rpx -8rpx rgba(4,37,65,0.21), inset 0 -1rpx 6rpx 0 rgba(20,59,92,0.34)',
    },
  },
}
